import Vue from 'vue'
import { Form, Input, Button, Row, Col, Layout, Divider, Descriptions, Space, Select, Modal } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import UserIcon from '@/components/icon'
import MobileInput from '@/components/mobile-input'

import './css/index.less'

Vue.use(Storage)
Vue.use(Form)
Vue.use(Input)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Space)
Vue.use(Layout)
Vue.use(Divider)
Vue.use(Descriptions)
Vue.use(Modal)
Vue.use(Select)
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(UserIcon)
Vue.use(MobileInput)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
